var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('byjove-app',{attrs:{"appsettings":_vm.appsettings,"include-footer":false},scopedSlots:_vm._u([{key:"footer",fn:function(){return [_c('router-link',{attrs:{"to":"/about"}},[_vm._v(_vm._s(_vm.appsettings.appTitle)+" "+_vm._s(_vm.appsettings.version))])]},proxy:true}])},[_c('app-nav')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }